import { render } from "./campus-overview.vue?vue&type=template&id=21ade180"
import script from "./campus-overview.vue?vue&type=script&lang=js"
export * from "./campus-overview.vue?vue&type=script&lang=js"
script.render = render

export default script